import { useEffect, useState } from "react";
import { Activity } from "lucide-react";
import api from "@/lib/api";

function fmt(iso) {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleString(); } catch { return iso; }
}

const ACTION_COLOR = {
  login: "bg-emerald-100 text-emerald-700",
  login_failed: "bg-rose-100 text-rose-700",
  logout: "bg-slate-100 text-slate-700",
};

export default function ActivityLog() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/activity-log").then((r) => setItems(r.data || []))
      .catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="activity-log-page">
      <h2 className="text-2xl font-display font-bold text-[#0F172A] flex items-center gap-2">
        <Activity className="w-6 h-6 text-[#1E3A8A]" /> Activity Log
      </h2>
      <p className="text-sm text-[#475569] mt-1">Recent administrative actions across the dashboard.</p>

      <div className="mt-6 bg-white rounded-2xl border border-slate-100 overflow-hidden">
        {loading ? (
          <div className="p-8 text-center text-sm text-[#475569]">Loading…</div>
        ) : items.length === 0 ? (
          <div className="p-12 text-center text-sm text-[#475569]" data-testid="activity-log-empty">No activity yet.</div>
        ) : (
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-left text-[11px] uppercase tracking-wider text-slate-500">
              <tr>
                <th className="px-4 py-3">When</th>
                <th className="px-4 py-3">User</th>
                <th className="px-4 py-3">Role</th>
                <th className="px-4 py-3">Action</th>
                <th className="px-4 py-3">Target</th>
                <th className="px-4 py-3">Details</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {items.map((row) => (
                <tr key={row.id} data-testid={`activity-row-${row.id}`}>
                  <td className="px-4 py-3 text-xs text-slate-500 whitespace-nowrap">{fmt(row.created_at)}</td>
                  <td className="px-4 py-3 text-[#0F172A]">{row.user_email || "—"}</td>
                  <td className="px-4 py-3 text-xs uppercase tracking-wider text-slate-500">{row.user_role || "—"}</td>
                  <td className="px-4 py-3">
                    <span className={`px-2 py-0.5 rounded-full text-[11px] font-semibold ${ACTION_COLOR[row.action] || "bg-blue-100 text-blue-700"}`}>{row.action}</span>
                  </td>
                  <td className="px-4 py-3 text-[#475569]">{row.target || "—"}</td>
                  <td className="px-4 py-3 text-[#475569] text-xs break-all">{row.details || ""}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
